import React, { useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import GetRequest from '../../../service/GetRequest';
import { FaMoneyBill, FaUsers, FaWallet } from "react-icons/fa";
import { FaShop } from "react-icons/fa6";
import QuickView from '../../DashboardComponents/QuickViewComponent';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

const TileSelection = () => {

    const [branchList, setBranchList] = useState([]);
    const [selectedBranchId, setSelectedBranchId] = useState(null);
    const [selectedBranch, setSelectedBranch] = useState({});
    const [selectedTiles, setSelectedTiles] = useState([]);

    const [tileValues, setTileValues] = useState({
        salesCount: null,
        ordersCount: 0,
        pendingOrdersCount: 0,
        mostSoldItemsCount: 0,
        lowStockItemsCount: 0,
        pendingRefundsCount: 0,
        cancelledOrdersCount: 0
    });

    const tiles = [
        { name: 'Customers', code: 'CS', icon: FaUsers, footer: 'Customers', data: tileValues.salesCount, iconColor: '#A550B3', backgroundColor: '#F6EDF7' },
        { name: 'Sales', code: 'SS', icon: FaMoneyBill, footer: 'Sales', data: tileValues.salesCount, iconColor: '#119FFA', backgroundColor: '#E7F5FE' },
        { name: 'Orders', code: 'OR', icon: FaMoneyBill, footer: 'Orders', data: tileValues.ordersCount, iconColor: '#FB890D', backgroundColor: '#FFF3E6' },
        { name: 'Pending order', code: 'PO', icon: FaMoneyBill, footer: 'Pending Orders', data: tileValues.pendingOrdersCount, iconColor: '#FB890D', backgroundColor: '#FFF3E6' },
        { name: 'Most sold', code: 'MS', icon: FaMoneyBill, footer: 'Most Sold', data: tileValues.mostSoldItemsCount, iconColor: '#FB890D', backgroundColor: '#FFF3E6' },
        { name: 'Low stock', code: 'LS', icon: FaMoneyBill, footer: 'Low Stock', data: tileValues.lowStockItemsCount, iconColor: '#FB890D', backgroundColor: '#FFF3E6' },
        { name: 'Pending refunds', code: 'PRS', icon: FaMoneyBill, footer: 'Pending Refunds', data: tileValues.pendingRefundsCount, iconColor: '#FB890D', backgroundColor: '#FFF3E6' },
        { name: 'Cancelled orders', code: 'CO', icon: FaMoneyBill, footer: 'Cancelled Orders', data: tileValues.cancelledOrdersCount, iconColor: '#FB890D', backgroundColor: '#FFF3E6' }
    ];

    const handleBranchChange = (e) => {
        const selectedBranch = branchList.find(branch => branch.id === e.value);
        setSelectedBranch(selectedBranch);
        setSelectedBranchId(e.value);
        console.log("selected branch city:", selectedBranch.city);
        console.log("Selected branch:", e.value);
    };

    useEffect(() => {
        if (selectedBranch.id) {
            console.log("branchId changed");
            fetchTileValues(selectedBranch.id);
        }
    }, [selectedBranch]);

    useEffect(() => {
        fetchStoreDetails();
    }, []);

    const fetchStoreDetails = () => {
        GetRequest("v1/store-management-service/view/my/store", true)
            .then(response => {
                if (!response || !response.storeBranches || response.storeBranches.length === 0) {
                    console.error("Empty response or undefined data for store branches");
                } else {
                    setBranchList(response.storeBranches);
                    setSelectedBranch(response.storeBranches[0]); // Select the first branch by default
                    setSelectedBranchId(response.storeBranches[0].id); // Select the first branch ID by default
                }
            })
            .catch(error => {
                console.error("Error fetching store details:", error);
            });
    };

    const fetchTileValues = (branchId) => {
        GetRequest(`http://192.168.4.112:2233/api/v1/analytics-service/view/branch/${branchId}/statistics`, true)
            .then(response => {
                if (response) {
                    setTileValues({
                        salesCount: response.salesCount,
                        ordersCount: response.ordersCount,
                        pendingOrdersCount: response.pendingOrdersCount,
                        mostSoldItemsCount: response.mostSoldItemsCount ? response.mostSoldItemsCount.Online : 0,
                        lowStockItemsCount: response.lowStockItemsCount,
                        pendingRefundsCount: response.pendingRefundsCount,
                        cancelledOrdersCount: response.cancelledOrdersCount
                    });
                }
            })
            .catch(error => {
                console.error("Error fetching tile values:", error);
            });
    };

    const itemTemplate = (option) => {
        return (
            <div className="p-multiselect-item">
                <i className={`pi ${option.icon} p-mr-2`} style={{ verticalAlign: 'middle' }}></i>
                <span>{option.name}</span>
            </div>
        );
    };

    const panelFooterTemplate = () => {
        const length = selectedTiles ? selectedTiles.length : 0;

        return (
            <div className="py-2 px-3">
                <b>{length}</b> item{length > 1 ? 's' : ''} selected.
            </div>
        );
    };

    return (
        <div>
            <div className='flex align-items-center justify-content-end mb-4' style={{ gap: '10px' }}>
                <Dropdown
                    value={selectedBranchId}
                    options={branchList.map(branch => ({ label: branch.name, value: branch.id }))}
                    onChange={handleBranchChange}
                    optionLabel="label"
                    placeholder="Select a Branch"
                    className="w-full md:w-14rem"
                    checkmark={true}
                    highlightOnSelect={false}
                />
                <div>
                    Custom Tiles
                    <MultiSelect
                        value={selectedTiles}
                        onChange={(e) => setSelectedTiles(e.value)}
                        options={tiles}
                        optionLabel="name"
                        itemTemplate={itemTemplate}
                        placeholder="Select Tiles"
                        maxSelectedLabels={3}
                        className="w-full md:w-20rem"
                        panelFooterTemplate={panelFooterTemplate}
                    />
                </div>
            </div>
            <br />
            <div className="dashboard-child-elements">
                {selectedTiles && selectedTiles.map(tile => (
                    <QuickView
                        key={tile.code}
                        data={tile.data}
                        icon={tile.icon}
                        footer={tile.footer}
                        iconColor={tile.iconColor}
                        backgroundColor={tile.backgroundColor}
                    />
                ))}
            </div>
        </div>
    )
}

export default TileSelection;
